import { render, staticRenderFns } from "./AccountMore.vue?vue&type=template&id=6922c8da&"
import script from "./AccountMore.vue?vue&type=script&lang=js&"
export * from "./AccountMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports